import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  IonicPage,
  LoadingController,
  NavController,
  NavParams,
} from "ionic-angular";
import { Storage } from "@ionic/storage";
import { ServiceProvider } from "./../../providers/service/service";
import { Http, RequestOptions, Headers } from "@angular/http";
import { TranslateService } from "@ngx-translate/core";
import { MerchantRentalRentComfirmPage } from "../merchant-rental-rent-comfirm/merchant-rental-rent-comfirm";

/**
 * Generated class for the MerchantRentalRentInputPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-merchant-rental-rent-input",
  templateUrl: "merchant-rental-rent-input.html",
})
export class MerchantRentalRentInputPage {
  private code: FormGroup;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {
    this.code = this.formBuilder.group({
      val: ["", Validators.compose([Validators.required])],
    });
  }

  async ionViewDidLoad() {
    console.log("เช่าพื้นที่ 2");
    this.theme = await this.storage.get("theme");
  }

  /** submit code ##เช่าพื้นที่ 2 */
  confirm() {
    // console.log(this.code.value.val);
    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });

    if (!this.code.value.val) {
      this.translateService
        .get("Code must not be empty.")
        .subscribe((value) => {
          this.services.presentToast(value);
        });
      return false;
    } else {
      loader.present();
      this.storage.get("token").then((token) => {
        var link = this.services.URLMerchantRentSpace;
        var headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", "Bearer " + token);
        const requestOptions = new RequestOptions({ headers: headers });
        this.http
          .post(
            link,
            {
              code: this.code.value.val,
            },
            requestOptions
          )
          .map((res) => res.json())
          .subscribe(
            (data) => {
              console.log(data);
              loader.dismiss();
              this.navCtrl.push(MerchantRentalRentComfirmPage, {
                result: {
                  code: data.code,
                  plaza_id: data.plaza.plaza_id,
                  plaza_name: data.plaza.plaza_name,
                  space_no: data.space_no,
                  shop_id: data.shop.shop_id,
                  shop_name: data.shop.shop_name,
                  discount: data.discount,

                  decoration: data.shop.decoration,
                  rental_fee: data.shop.rental_fee,
                  cost: data.shop.stock_cost,
                  max_stock: data.shop.max_stock,
                  total_cost: data.total_cost,

                  // action:"rent"
                },
              });
            },
            (error) => {
              var response = JSON.parse(error._body);
              this.translateService.get(response.message).subscribe((value) => {
                this.services.presentToast(value);
              });
              loader.dismiss();
            }
          );
      });
    }
  }

  backPage() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/merchant-rental-rent-input/merchant-rental-rent-input.ts